import React from 'react'
import { Box, BoxProps } from '@mui/material'

export type BoxWrapperProps = BoxProps

export default function BoxWrapper(props: BoxWrapperProps) {
  return <Box border="1px solid" borderColor="gray.700" bgcolor="gray.800" {...props} />
}
